<template>
  <div class="w100 pt20 topic-office">
    <div class="w120 mc pt20 ">
      <div v-for="item in moduleData.cardModules" :key="item.code">
        <p class="w100 font-36 tx-c">专题事项</p>
        <div class="list-box">
          <el-row :gutter="20">
            <el-col :style="`width: ${handleWidth(item.col || 4)}`" v-for="e in item.data" :key="e.topicId" class="topic-office-col">
              <div class="tx-c bg-w pic-box mb20">
                <img :src="e.topicFileUrl" alt="" width="100%" height="150px">
                <p class="font-22 lh30 ellipsis">{{e.topicName}}</p>
                <div class="font-16 grey flex-box serve-list">
                  <template v-for="(ee, ii) in e.serveList">
                    <el-tooltip v-if="ee.serveName.length >10" effect="dark" :content="ee.serveName" placement="top-start">
                      <span style="cursor: pointer" @click="goServe(ee)">{{(ee.serveName).substr(0,10) + '...'}}</span>
                    </el-tooltip>
                    <span style="cursor: pointer" v-else @click="goServe(ee)">{{ee.serveName}}</span>
                    <span class="mb-auto" v-if="ii<e.serveList.length-1" :key="ee.serveId">&nbsp;|&nbsp;</span>
                    
                  </template>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "TOPIC",
  components: {},
  props: ['moduleData'],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
    };
  },
  computed: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    handleWidth(col){
      switch (col) {
        case 1:
          return '100%'
        case 2:
          return '50%'
        case 3:
          return '33.3%'
        case 4:
          return '25%'
        case 5:
          return '20%'
        case 6:
          return '16.6%'
        default:
          return '50%'
      }
    },
    goServe(item){
        let routeData = null
        if(item.serveType == '0' && item.queryType == '2'){ // 本地查询类
            routeData = this.$router.resolve({
                name: item.queryPcUrl,
            });
            window.open(routeData.href);
        }
        if(item.serveType == '0' && item.queryType == '1'){ //流程查询类
            window.open(item.queryPcUrl);
        }else {
            routeData = this.$router.resolve({
                path: `/ServeCenterDetail?id=${item.serveId}`
            });
            window.open(routeData.href);
        }
    },
  },
  watch: {},
  filters: {},
};
</script>

<style scoped lang="less">
.list-box {
  padding: 40px 0 20px;
}
.item-box:hover,
.pic-box:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.lh30 {
  line-height: 58px;
}
.serve-list {
  height: 64px;
  flex-wrap: wrap;
  /* padding: 0 6px; */
  justify-content: center;
  overflow-y: scroll;
}
.serve-item {
  cursor: pointer;
  user-select: none;
  /* margin-left: auto;
  margin-right: auto; */
}
.mb-auto{
  margin-bottom: auto;
  line-height: 1;
}
.topic-office {
  .topic-office-col {
    display: flex;
    justify-content: center;
    .pic-box {
      cursor: unset;
      width: 285px;
      height: 275px;
    }
  }
}
</style>
